import Phaser from "phaser";
import gameConfig from "./gameConfig";

export default class IPC extends Phaser.Physics.Arcade.Sprite {
    #ipcID;
    #attribute;
    isNPC;
    pNPC;

    constructor(scene, x, y, id, _callback, _keyState) {
        super(scene, x, y, id);
        scene.add.existing(this)
        scene.physics.add.existing(this);
        this.setScale(1);

        this.#ipcID = id;
        this.#attribute = {
            Strength: 0,
            StrengthAttributes: {
                Force: 0,
                Sustain: 0,
                Tolerance: 0
            },
            Dexterity: 0,
            DexterityAttributes: {
                Speed: 0,
                Precision: 0,
                Reaction: 0
            },
            Intelligence: 0,
            IntelligenceAttributes: {
                Memory: 0,
                Processing: 0,
                Reasoning: 0
            },
            Constitution: 0,
            ConstitutionAttributes: {
                Healing: 0,
                Fortitude: 0,
                Vitality: 0
            },
            Luck: 0,
            DNA: {
                Race: '',
                Subrace: '',
                Gender: '',
                SkinColor: '',
                HairColor: '',
                EyeColor: '',
                Handedness: ''
            },

        };
        this._callback = _callback;

        this.dir = 0;

        if (_keyState === null) {
            this.isNPC = true;
            this.pNPC = this;
            this.ChangeDirection();
        }
        else {
            this.keyState = _keyState;
            this.isNPC = false;
            this.pNPC = null;
        }

        this.ipcSpeed = 400;

        this.npcStart = false;

        this.deltaX = 0;
        this.deltaY = 0;


        this.getIpcRequest(this);
        this.setSpritesheet(scene)
    }


    ChangeDirection() {
        var direction = Math.floor(Math.random() * 4);
        while (this.dir === direction) {
            direction = Math.floor(Math.random() * 4);
        }
        if (direction === 0) { //NORTH
            this.deltaX = 0;
            this.deltaY = this.ipcSpeed;
        }
        else if (direction === 1) { //south

            this.deltaX = 0;
            this.deltaY = -this.ipcSpeed;
        }
        else if (direction === 2) { //east
            this.setFlipX(false);
            this.deltaX = this.ipcSpeed;
            this.deltaY = 0;
        }
        else if (direction === 3) {
            this.setFlipX(true);
            this.deltaX = -this.ipcSpeed;
            this.deltaY = 0;
        }
        this.dir = direction;

    }

    getID() { return this.#ipcID };

    getStrength() { return this.#attribute.Strength; };
    getForce() { return this.#attribute.StrengthAttributes.Force; };
    getSustain() { return this.#attribute.StrengthAttributes.Sustain; };
    getTolerance() { return this.#attribute.StrengthAttributes.Tolerance; };

    getDexterity() { return this.#attribute.Dexterity; };
    getSpeed() { return this.#attribute.DexterityAttributes.Speed; };
    getPrecision() { return this.#attribute.DexterityAttributes.Precision; };
    getReaction() { return this.#attribute.DexterityAttributes.Reaction; };

    getIntelligence() { return this.#attribute.Intelligence; };
    getMemory() { return this.#attribute.IntelligenceAttributes.Memory; };
    getProcessing() { return this.#attribute.IntelligenceAttributes.Processing; };
    getReasoning() { return this.#attribute.IntelligenceAttributes.Reasoning; };

    getConstitution() { return this.#attribute.Constitution; };
    getHealing() { return this.#attribute.ConstitutionAttributes.Healing; };
    getFortitude() { return this.#attribute.ConstitutionAttributes.Fortitude; };
    getVitality() { return this.#attribute.ConstitutionAttributes.Vitality; };

    getLuck() { return this.#attribute.Luck; };

    getRace() { return this.#attribute.DNA.Race; };
    getSubrace() { return this.#attribute.DNA.Subrace; };
    getGender() { return this.#attribute.DNA.Gender; };
    getSkinColor() { return this.#attribute.DNA.SkinColor; };
    getHairColor() { return this.#attribute.DNA.HairColor; };
    getEyeColor() { return this.#attribute.DNA.EyeColor; };
    getHandedness() { return this.#attribute.DNA.Handedness; };



    setSpritesheet(scene) {
        const ipcID = this.getID();
        if (!scene.textures.exists(ipcID+'_sprite')) {
            console.warn(`🧨 Texture "${ipcID}" still not found`);
            return;
        }

        this._callback(this);
        
        this.setTexture(ipcID+'_sprite', 0);

        const animKey = `${ipcID}anim`;

        if (!scene.anims.exists(animKey)) {
            scene.anims.create({
                key: animKey,
                frameRate: 10,
                frames: scene.anims.generateFrameNumbers(ipcID+'_sprite', { start: 7, end: 0 }),
                repeat: -1
            });
        }

        this.playReverse(animKey);
    }

    getIpcRequest(ipc) {
        const ipcID = this.getID();
        const url = `${gameConfig.public_root}token_id/${ipcID}`;

        const Http = new XMLHttpRequest();
        Http.open("GET", url);
        Http.send();

        Http.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                try {
                    const jsonObj = JSON.parse(Http.responseText);
                    ipc.#setAttributes(jsonObj);
                    ipc.setFlipX(ipc.getHandedness() === "Left");

                } catch (err) {
                    console.error(`❌ Error in getIpcRequest(${ipcID}):`, err);
                    ipc.destroy();
                }
            }
        };
    }
    #setAttributes(jsonObj) {
        var tmp = jsonObj.responce;
        // for (var i in jsonObj.responce)
        // {
        //     tmp[jsonObj.responce[i]] = jsonObj.responce[i].value;
        // }

        this.#attribute.Strength = tmp['strength'];
        this.#attribute.StrengthAttributes.Force = tmp['force'];
        this.#attribute.StrengthAttributes.Sustain = tmp['sustain'];
        this.#attribute.StrengthAttributes.Tolerance = tmp['tolerance'];

        this.#attribute.Dexterity = tmp['dexterity'];
        this.#attribute.DexterityAttributes.Speed = tmp['speed'];
        this.#attribute.DexterityAttributes.Precision = tmp['precision'];
        this.#attribute.DexterityAttributes.Reaction = tmp['reaction'];

        this.#attribute.Intelligence = tmp['intelligence'];
        this.#attribute.IntelligenceAttributes.Memory = tmp['memory'];
        this.#attribute.IntelligenceAttributes.Processing = tmp['processing'];
        this.#attribute.IntelligenceAttributes.Reasoning = tmp['reasoning'];

        this.#attribute.Constitution = tmp['constittuion'];
        this.#attribute.ConstitutionAttributes.Healing = tmp['healing'];
        this.#attribute.ConstitutionAttributes.Fortitude = tmp['fortitude'];
        this.#attribute.ConstitutionAttributes.Vitality = tmp['vitality'];

        this.#attribute.DNA.Race = tmp['race'];
        this.#attribute.DNA.Subrace = tmp['subrace'];
        this.#attribute.DNA.Gender = tmp['gender'];
        this.#attribute.DNA.SkinColor = tmp['skin_color'];
        this.#attribute.DNA.HairColor = tmp['hair_color'];
        this.#attribute.DNA.EyeColor = tmp['eye_color'];
        this.#attribute.DNA.Handedness = tmp['handedness'];

    }

    update() {

        if (this.isNPC) {
            if (this.npcStart) {
                this.setVelocity(this.deltaX, this.deltaY);
            }
            return;
        }

        if (!this.keyState.left.isUp) {
            this.setFlipX(true);
            this.setVelocity(-this.ipcSpeed, 0);

        }
        else if (!this.keyState.right.isUp) {
            this.setFlipX(false);
            this.setVelocity(this.ipcSpeed, 0);
        }
        else if (!this.keyState.up.isUp) {

            this.setVelocity(0, -this.ipcSpeed);

        }
        else if (!this.keyState.down.isUp) {

            this.setVelocity(0, this.ipcSpeed);

        }
        else {
            this.setVelocity(0, 0);
        }
    }

    moveTo(x, y) {

    }

}